module.exports = __webpack_public_path__ + "8c407bd70b3595192cf89bd5d4a1b9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/minus_redesign.png
// module id = 81
// module chunks = 0